var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bgd-image container rounded-xl",style:({
    background: 'url(' + _vm.blok.image.filename + '/m/' + ')',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }